import React from "react";

function Modal({ setOpenModal }) {
    return (
        <div className="modalContainer">
            <div className="titleCloseBtn">
                <button
                    onClick={() => {
                        setOpenModal(false);
                    }}
                >
                    X
                </button>
            </div>
            <div className="modal-body">
                <div className="modal-title">แก้ไขข้อมูล</div>
                <table className="insight-table">
                    <tr>
                        <th>ประเทศ</th>
                        <th>กำลังการผลิต</th>
                        <th>ผลิตจริง</th>
                        <th>%ใช้งาน</th>
                        <th id="th-color">%ใช้เอง</th>
                        <th id="th-color">%ขายลูกค้า</th>
                    </tr>
                    <tr>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                    </tr>
                    <tr>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                    </tr><tr>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                    </tr><tr>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                    </tr><tr>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                    </tr>
                    <tr id="tr-color">
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                        <td><input></input></td>
                    </tr>
                </table>
            </div>
            <div className="footer">
                <button
                    onClick={() => {
                        setOpenModal(false);
                    }}
                    id="cancelBtn"
                >
                    ยกเลิก
                </button>
                <button>ตกลง</button>
            </div>
        </div>
    );
}

export default Modal;